import { Components, Theme } from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    linkButton: true;
    listButton: true;
    backButton: true;
    tooltip: true;
  }
}

const MuiButton: Components<Theme>["MuiButton"] = {
  styleOverrides: {
    root: {
      textTransform: "none",
    },
    sizeSmall: {
      fontSize: "12px",
      lineHeight: "22px",
      padding: "4px 10px",
    },
    sizeMedium: {
      fontSize: "14px",
      lineHeight: "24px",
      padding: "6px 16px",
    },
    sizeLarge: {
      fontSize: "16px",
      lineHeight: "26px",
      padding: "8px 22px",
    },
    text: {
      "&.MuiButton-sizeSmall": {
        padding: "4px 5px",
      },
      "&.MuiButton-sizeMedium": {
        padding: "6px 8px",
      },
      "&.MuiButton-sizeLarge": {
        padding: "8px 11px",
      },
    },
  },
};

export default MuiButton;
